module.exports = __webpack_public_path__ + "assets/img/yuyue_title.56df023a.png";